import { useMemo } from 'react';
import type { Size } from './useContainerSize';

export function useScale(image: { width: number; height: number } | null, containerSize: Size): number {
  return useMemo(() => {
    if (!image) return 1;
    if (image.width === 0 || image.height === 0) return 1;
    return Math.min(containerSize.width / image.width, containerSize.height / image.height);
  }, [image, containerSize.width, containerSize.height]);
}
